<template>
  <span>
    <Tooltip
      class="pa-8"
      :color="tooltipColor"
      :text="tooltipText"
      top
    >
      <!-- IconRemove.vue -->
      <v-btn
        v-bind="attrs"
        icon
        size="small"
        variant="text"
        @click="openConfirmationDialog = true" 
      >
        <v-icon :color="iconColor" size="small">
          {{ iconName }}
        </v-icon>
      </v-btn>

    </Tooltip>

    <DialogConfirmation
      v-if="openConfirmationDialog"
      :title="dialogTitle"
      type="warning"
      :opened="openConfirmationDialog"
      @on-submit="submit"
      @on-cancel="openConfirmationDialog = false"
    >
      {{ dialogText }}
    </DialogConfirmation>
  </span>
</template>

<script setup>
import { ref, computed, useAttrs } from 'vue'
import DialogConfirmation from '@/components/ui/DialogConfirmation.vue'
import Tooltip from '@/components/ui/Tooltip.vue'

defineOptions({ name: 'uiIconRemove', inheritAttrs: false })
const props = defineProps({
  reverse: { type: Boolean, default: false },
  tooltipColor: {type: String, default: "error"}
})
const emit = defineEmits(['on-submit'])

const attrs = useAttrs()
const openConfirmationDialog = ref(false)

/* --- UI derivada do modo (remover/restaurar) --- */
const tooltipText = computed(() => (props.reverse ? 'Restaurar' : 'Remover'))
// const tooltipColor = computed(() => (props.reverse ? 'warning' : 'error'))
const iconName = computed(() => (props.reverse ? 'mdi-backup-restore' : 'mdi-delete'))
const iconColor = computed(() => (props.reverse ? 'warning' : 'error'))
const dialogTitle = computed(() => (props.reverse ? 'Restaurar Item' : 'Remover Item'))
const dialogText = computed(() =>
  props.reverse
    ? 'Tem a certeza que pretende restaurar o item?'
    : 'Tem a certeza que pretende remover o item?'
)

function submit () {
  openConfirmationDialog.value = false
  emit('on-submit')
}
</script>

<style scoped>
/* (sem estilos extra) */
</style>
